import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './Privacy Policy.css';

const PrivacyPolicy = () => {
  return (
    <div className='privacy-container'>
        <Navbar />
        <div className="privacy-policy-page">
            <h1>Privacy Policy</h1>
            <p><strong>Last Updated:</strong> September 7, 2025</p>
            
            <h2>Introduction</h2>
            <p>
                At LeetEngineer ("we," "us," or "our"), we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered engineering interview preparation and resume building platform.
            </p>
            
            <h2>Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
                <li><strong>Personal Information:</strong> Name, email address, and account details when you sign up.</li>
                <li><strong>Job Posting Data:</strong> The job postings you paste into our platform for generating questions and resumes.</li>
                <li><strong>Resume Data:</strong> Personal information, experience, education, and skills you provide for resume building.</li>
                <li><strong>Usage Data:</strong> Information about how you interact with our platform, including generated questions, answers, and resumes.</li>
                <li><strong>Technical Data:</strong> IP address, browser type, and device information for security and analytics.</li>
            </ul>
            
            <h2>How We Use Your Information</h2>
            <p>We use the collected information to:</p>
            <ul>
                <li>Personalize your experience and generate tailored interview questions and professional resumes</li>
                <li>Communicate with you about your account and our services</li>
                <li>Ensure the security and integrity of our platform</li>
                <li>Analyze usage patterns to enhance our platform</li>
            </ul>
            
            <h2>Data Security</h2>
            <p>
                We implement industry-standard security measures, including encryption and secure data handling practices, to protect your information. 
                We never share your personal information or job application details with third parties without your consent, except as required by law.
            </p>
            
            <h2>Data Sharing and Disclosure</h2>
            <p>
                We do not sell, trade, or otherwise transfer your personal information to third parties. We may share information only in the following circumstances:
            </p>
            <ul>
                <li>With your explicit consent</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights or the safety of others</li>
                <li>In connection with a business transfer (e.g., merger or acquisition)</li>
            </ul>
            
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
                <li>Access and update your personal information</li>
                <li>Request deletion of your data</li>
                <li>Opt out of certain data processing activities</li>
                <li>Request data portability</li>
            </ul>
            
            <h2>Cookies and Tracking</h2>
            <p>
                We may use cookies and similar technologies to enhance your experience, analyze usage, and provide personalized content. 
                You can control cookie settings through your browser preferences.
            </p>
            
            <h2>Children's Privacy</h2>
            <p>
                Our services are not intended for children under 13. We do not knowingly collect personal information from children under 13.
            </p>
            
            <h2>Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on our website.
            </p>
            
            <h2>Contact Us</h2>
            <p>
                If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@leetengineerai.com">support@leetengineerai.com</a>.
            </p>
    </div>
       <Footer />
    </div>
  );
};

export default PrivacyPolicy;
